import { ApplicationStatus } from '../../../Lib/Constants/vendor-application-form-step';

export default function determineApplicationStage(application) {
  switch (application.application_stage) {
    case ApplicationStatus.INITIATED:
      return 'Initiate Vendor Application';
    case ApplicationStatus.VENDOR_QUESTIONNAIRE:
      return 'FN Vendor Questionnaire';
    case ApplicationStatus.BUYER_QUESTIONNAIRE:
      return 'Buyer Questionnaire';
    case ApplicationStatus.SPONSOR_APPROVAL:
      return 'Sponsor Approval';
    case ApplicationStatus.SPONSOR_DENIED:
      return 'Sponsor Denial';
    case ApplicationStatus.FIRST_EXECUTIVE_APPROVAL:
      return 'Executive 1 Approval';
    case ApplicationStatus.FIRST_EXECUTIVE_DENIED:
      return 'Executive 1 Denial';
    case ApplicationStatus.SECOND_EXECUTIVE_APPROVAL:
      return 'Executive 2 Approval';
    case ApplicationStatus.SECOND_EXECUTIVE_DENIED:
      return 'Executive 2 Denial';
    case ApplicationStatus.PRE_ONBOARDING:
      return 'Pre-Onboarding';
    case ApplicationStatus.APPROVED:
      return 'Vendor Onboarded';
    default:
      return 'N/A';
  }
}
